/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { OffsetPaginationDto } from '../models/offset-pagination-dto';
import { sponsorControllerCreateV1 } from '../fn/sponsor/sponsor-controller-create-v-1';
import { SponsorControllerCreateV1$Params } from '../fn/sponsor/sponsor-controller-create-v-1';
import { sponsorControllerDeleteV1 } from '../fn/sponsor/sponsor-controller-delete-v-1';
import { SponsorControllerDeleteV1$Params } from '../fn/sponsor/sponsor-controller-delete-v-1';
import { sponsorControllerFindAllV1 } from '../fn/sponsor/sponsor-controller-find-all-v-1';
import { SponsorControllerFindAllV1$Params } from '../fn/sponsor/sponsor-controller-find-all-v-1';
import { sponsorControllerFindByIdV1 } from '../fn/sponsor/sponsor-controller-find-by-id-v-1';
import { SponsorControllerFindByIdV1$Params } from '../fn/sponsor/sponsor-controller-find-by-id-v-1';
import { sponsorControllerReorderV1 } from '../fn/sponsor/sponsor-controller-reorder-v-1';
import { SponsorControllerReorderV1$Params } from '../fn/sponsor/sponsor-controller-reorder-v-1';
import { sponsorControllerSearchV1 } from '../fn/sponsor/sponsor-controller-search-v-1';
import { SponsorControllerSearchV1$Params } from '../fn/sponsor/sponsor-controller-search-v-1';
import { sponsorControllerToggleExposedV1 } from '../fn/sponsor/sponsor-controller-toggle-exposed-v-1';
import { SponsorControllerToggleExposedV1$Params } from '../fn/sponsor/sponsor-controller-toggle-exposed-v-1';
import { sponsorControllerUpdateV1 } from '../fn/sponsor/sponsor-controller-update-v-1';
import { SponsorControllerUpdateV1$Params } from '../fn/sponsor/sponsor-controller-update-v-1';
import { SponsorDto } from '../models/sponsor-dto';

@Injectable({ providedIn: 'root' })
export class SponsorService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `sponsorControllerSearchV1()` */
  static readonly SponsorControllerSearchV1Path = '/api/v1/sponsor/search';

  /**
   * Sponsor 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sponsorControllerSearchV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  sponsorControllerSearchV1$Response(params?: SponsorControllerSearchV1$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<SponsorDto>;
}>> {
    return sponsorControllerSearchV1(this.http, this.rootUrl, params, context);
  }

  /**
   * Sponsor 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sponsorControllerSearchV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  sponsorControllerSearchV1(params?: SponsorControllerSearchV1$Params, context?: HttpContext): Observable<OffsetPaginationDto & {
'items'?: Array<SponsorDto>;
}> {
    return this.sponsorControllerSearchV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<SponsorDto>;
}>): OffsetPaginationDto & {
'items'?: Array<SponsorDto>;
} => r.body)
    );
  }

  /** Path part for operation `sponsorControllerFindAllV1()` */
  static readonly SponsorControllerFindAllV1Path = '/api/v1/sponsor';

  /**
   * 모든 Sponsor 목록 조회 (노출된 것만).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sponsorControllerFindAllV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  sponsorControllerFindAllV1$Response(params?: SponsorControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SponsorDto>>> {
    return sponsorControllerFindAllV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 모든 Sponsor 목록 조회 (노출된 것만).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sponsorControllerFindAllV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  sponsorControllerFindAllV1(params?: SponsorControllerFindAllV1$Params, context?: HttpContext): Observable<Array<SponsorDto>> {
    return this.sponsorControllerFindAllV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<SponsorDto>>): Array<SponsorDto> => r.body)
    );
  }

  /** Path part for operation `sponsorControllerCreateV1()` */
  static readonly SponsorControllerCreateV1Path = '/api/v1/sponsor';

  /**
   * Sponsor 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sponsorControllerCreateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sponsorControllerCreateV1$Response(params: SponsorControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<SponsorDto>> {
    return sponsorControllerCreateV1(this.http, this.rootUrl, params, context);
  }

  /**
   * Sponsor 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sponsorControllerCreateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sponsorControllerCreateV1(params: SponsorControllerCreateV1$Params, context?: HttpContext): Observable<SponsorDto> {
    return this.sponsorControllerCreateV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<SponsorDto>): SponsorDto => r.body)
    );
  }

  /** Path part for operation `sponsorControllerFindByIdV1()` */
  static readonly SponsorControllerFindByIdV1Path = '/api/v1/sponsor/{id}';

  /**
   * Sponsor id로 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sponsorControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  sponsorControllerFindByIdV1$Response(params: SponsorControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<SponsorDto>> {
    return sponsorControllerFindByIdV1(this.http, this.rootUrl, params, context);
  }

  /**
   * Sponsor id로 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sponsorControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  sponsorControllerFindByIdV1(params: SponsorControllerFindByIdV1$Params, context?: HttpContext): Observable<SponsorDto> {
    return this.sponsorControllerFindByIdV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<SponsorDto>): SponsorDto => r.body)
    );
  }

  /** Path part for operation `sponsorControllerDeleteV1()` */
  static readonly SponsorControllerDeleteV1Path = '/api/v1/sponsor/{id}';

  /**
   * Sponsor 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sponsorControllerDeleteV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  sponsorControllerDeleteV1$Response(params: SponsorControllerDeleteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return sponsorControllerDeleteV1(this.http, this.rootUrl, params, context);
  }

  /**
   * Sponsor 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sponsorControllerDeleteV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  sponsorControllerDeleteV1(params: SponsorControllerDeleteV1$Params, context?: HttpContext): Observable<boolean> {
    return this.sponsorControllerDeleteV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `sponsorControllerUpdateV1()` */
  static readonly SponsorControllerUpdateV1Path = '/api/v1/sponsor/{id}';

  /**
   * Sponsor 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sponsorControllerUpdateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sponsorControllerUpdateV1$Response(params: SponsorControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<SponsorDto>> {
    return sponsorControllerUpdateV1(this.http, this.rootUrl, params, context);
  }

  /**
   * Sponsor 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sponsorControllerUpdateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sponsorControllerUpdateV1(params: SponsorControllerUpdateV1$Params, context?: HttpContext): Observable<SponsorDto> {
    return this.sponsorControllerUpdateV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<SponsorDto>): SponsorDto => r.body)
    );
  }

  /** Path part for operation `sponsorControllerReorderV1()` */
  static readonly SponsorControllerReorderV1Path = '/api/v1/sponsor/reorder';

  /**
   * 스폰서 순서 변경.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sponsorControllerReorderV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sponsorControllerReorderV1$Response(params: SponsorControllerReorderV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return sponsorControllerReorderV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 스폰서 순서 변경.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sponsorControllerReorderV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  sponsorControllerReorderV1(params: SponsorControllerReorderV1$Params, context?: HttpContext): Observable<boolean> {
    return this.sponsorControllerReorderV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `sponsorControllerToggleExposedV1()` */
  static readonly SponsorControllerToggleExposedV1Path = '/api/v1/sponsor/{id}/toggle-exposed';

  /**
   * Sponsor 노출 여부 토글.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sponsorControllerToggleExposedV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  sponsorControllerToggleExposedV1$Response(params: SponsorControllerToggleExposedV1$Params, context?: HttpContext): Observable<StrictHttpResponse<SponsorDto>> {
    return sponsorControllerToggleExposedV1(this.http, this.rootUrl, params, context);
  }

  /**
   * Sponsor 노출 여부 토글.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `sponsorControllerToggleExposedV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  sponsorControllerToggleExposedV1(params: SponsorControllerToggleExposedV1$Params, context?: HttpContext): Observable<SponsorDto> {
    return this.sponsorControllerToggleExposedV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<SponsorDto>): SponsorDto => r.body)
    );
  }

}
